import { createApiRef } from '@backstage/core-plugin-api';
import type {
  AgentOut,
  AgentSchemaOut,
  DiscoveryQuery,
  DiscoveryResponse,
  DriftFlagOut,
} from './types';

export interface AgentRegistryApi {
  discoverAgents(query?: DiscoveryQuery): Promise<DiscoveryResponse>;
  getAgent(name: string): Promise<AgentOut>;
  getAgentVersions(name: string): Promise<AgentOut[]>;
  getAgentSchema(name: string): Promise<AgentSchemaOut>;
  getAgentFlags(name: string): Promise<DriftFlagOut[]>;
}

export const agentRegistryApiRef = createApiRef<AgentRegistryApi>({
  id: 'plugin.agent-registry.service',
});
